export default __webpack_public_path__ + "static/media/HeroBackground@xs.0f3a09ed.jpg";